/**
 * What this prototype does not answer yet — the questions the screens raised
 * while they were being built, kept next to the screens themselves so a
 * reviewer reads them in front of the thing they are about.
 *
 * Prototype-only: shown from the dev bar, never part of the app.
 */

export type QuestionSection = {
  title: string;
  questions: string[];
};

export const OPEN_QUESTIONS: QuestionSection[] = [
  {
    title: "For Nick & Jordan",
    questions: ["Naming: licensee / payor / licensor? (to discuss on the sync)"],
  },
  {
    title: "For Vlad",
    questions: [
      "PDF extraction for contracts out – licensing contracts look very different from artist contracts. Can the current extraction handle them?",
    ],
  },
  {
    // Answered already — kept in the panel so a reviewer can see what is settled
    // as well as what is still open.
    title: "Decided",
    questions: [
      "Contract out fields: release date, formats released and contract PDF. Additional notes and other LabelWorks fields are left out for now.",
      "Contact name and email belong to the licensee.",
      "Separate Licensees page. One licensee per contract out.",
      "Compilation license vs sub-license only describes how the track is used – no accounting difference apart from the pro-rata share on compilations, which the licensee calculates.",
      "A licensing deal without a specific release (e.g. Dubset) is a sub-license.",
      "An advance can be fully, partially or not recoupable.",
      "An artist advance is generally recouped 100% from the payee side (off-the-top recoupment is an edge case for later).",
      "One-off flat fees are entered through sales entry (planned feature).",
      "Contract term uses start and end dates (both can be empty), as in contracts in.",
      "Licensed tracks follow the same rules as associated tracks in contracts in.",
      'One "Licensee royalty %" field for now – no rates per format.',
      "Advance amount is per track; if it's partially recoupable, the recoupable part is set for the whole contract.",
      "An advance from a licensee is not paid to the payee straight away – it's reported as income on their next royalty statement, like any other revenue.",
      'A track signed but not used on the compilation – deleting the contract out is enough, no "Cancelled" status needed.',
      "Invoicing licensees is handled outside Track for now.",
      "An artist contract shows the third-party licenses for its tracks.",
      "A sales entry has one contract out but can cover several tracks, each with its own amount.",
      "Physical products go on a release with units; digital sales go on tracks with units.",
      "Contracts are shown as tabs (Contracts in / Contracts out), with Contracts in as the default tab.",
      "Licensing type stays – it's informational only and doesn't affect accounting.",
      "Release date and formats released stay as optional, informational fields.",
      "The recoupable part of an advance stays a fixed amount, not a percentage.",
      "An advance reaches Track as a sales entry.",
      "Contract out progress works the same way as contract in.",
    ],
  },
  {
    title: "Separate task",
    questions: [
      "Advances are being handled as a separate task – the details still need to be agreed. What's in this prototype is a first pass.",
    ],
  },
  {
    title: "Sales entry",
    questions: [
      "Should sales entries live in one list with statements (filtered by entry type) or in a separate tab? Both versions are in the prototype – Nick leans towards one list.",
      "We assume a sales entry doesn't go through settlement – the label enters the amount they already received, in their own currency, so there's nothing to reconcile. Is that right? (for Vlad and Nick)",
      "LabelWorx ties a simple sales entry only to a licensee and a sales type, not to a contract out or specific tracks. We tie it to tracks so it lands on the right payee statement – Nick, does that work for you?",
      'We call it "sales entry" in the UI instead of LabelWorx\'s "simple sales entry" – does that work, or should we keep their wording since labels may know it?',
      "For physical products a sales entry goes on the whole release with one amount, but Track calculates revenue per track – how does that amount reach the artists? Nick said the system only recognises revenue per track today and that will need to change eventually.",
    ],
  },
  {
    title: "Later – licensee statements",
    questions: [
      "Importing statements from licensees isn't designed yet – revenue from licensing goes in as a sales entry for now. Still to answer: what format do the statements come in (pdf or csv/excel), does every licensee send a different one, is it one amount per period or split per track, and is the amount already deducted or their full earnings? Waiting for example statements from Nick.",
      "Agreed earlier, for when we pick this up: licensee statements will be imported as a file. Not part of this prototype.",
    ],
  },
];
